<template>
  <Layout>
    <template v-slot:navigation>
      <navtransparent />
    </template>
    <template v-slot:content>
      <header>
        <div class="container">
          <div class="row">
            <div class="col-md-5 mt-auto mb-auto text-light">
              <h2>Discover Innovative Startups Here</h2>
              <p>
                Filter through, partner, invest or work with our portdolio startups across the country.
              </p>
              <button class="btn btn-orange pl-5 pr-5 h5">Login</button>
            </div>

            <div class="col-md-6 ml-auto mr-auto d-none d-md-block">
              <img
                src="../../public/assets/images/back-girls.png"
                class="img-fluid text-center"
                alt="back girls"
              />
            </div>
          </div>
        </div>
      </header>

      <div class="custom-container-fluid">
        <div class="row" style="margin-top:-7rem">
          <div class="col-md-10 offset-md-1">
            <div
              class="card"
              style="background: linear-gradient(0deg, rgba(242, 101, 38, 0.15), rgba(242, 101, 38, 0.15)), #FFFFFF;"
            >
              <div class="card-body">
                <div class="row">
                  <div
                    class="col-md-4 border-right text-center mt-auto mb-auto"
                  >
                    <div
                      class="h2 stats font-weight-bold"
                      style="background: url('../../assets/images/back-1.png')"
                    >
                      {{ data["companies"] }}
                    </div>
                    <div>Companies</div>
                  </div>
                  <div
                    class="col-md-4 border-right text-center mt-auto mb-auto"
                  >
                    <div
                      class="h2 stats font-weight-bold"
                      style="background: url('../../assets/images/back-2.png')"
                    >
                      {{ data["no_of_founders"] }}
                    </div>
                    <div>No of Founders</div>
                  </div>
                  <div class="col-md-4 text-center mt-auto mb-auto">
                    <div
                      class="h2 stats font-weight-bold"
                      style="background: url('../../assets/images/back-3.png')"
                    >
                      {{ data["no_of_sectors"] }}
                    </div>
                    <div>Categories</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <h3 class="text-green font-weight-bold explore-heading">
              Explore Our Categories
            </h3>
            <div class="text-muted">Find startups by type</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 offset-md-1 text-center mb-5" v-if="error">
            <img
              src="../../public/assets/images/error.png"
              style="width: 200px"
              class="img-fluid"
              alt=""
            />
            <h5>
              Error whiles getting startups
            </h5>
          </div>
          <div class="col-md-10 offset-md-1">
            <div class="row mt-5 mb-5" v-if="isLoading">
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="photo shine" />
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-3" v-for="(d, i) in data['sectors']" :key="i">
                <router-link
                  :to="'/startup-database/' + d['id']"
                  class="card text-center bg-orange explore-card cursor-pointer"
                >
                  <div class="overlay">
                    <img
                      class="card-img-top"
                      :src="d['image_url']"
                      style="border-top-left-radius: 10px; border-top-right-radius: 10px; height:176px; object-fit: cover;"
                      alt="Card image cap"
                    />
                  </div>
                  <div class="card-body">
                    <div
                      class="card-text font-weight-bold"
                      style="font-size: 18px"
                    >
                      {{ d["category"] }}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
/* eslint-disable */

import layout from "@/components/app-layout";
import navigation from "@/components/topNav";
import axios from "axios";

export default {
  components: {
    Layout: layout,
    navtransparent: navigation
  },
  data: () => {
    return {
      data: {
        no_of_founders: 0,
        no_of_sectors: 0,
        companies: 0,
        sectors: []
      },
      isLoading: false,
      error: false
    };
  },
  methods: {
    getStats() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_ENDPOINT_BASE_URL}/statistics`)
        .then(res => {
          this.data = res.data.data;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {},
  mounted() {
    this.$loadScript("https://sdk.amazonaws.com/js/aws-sdk-2.16.0.min.js")
      .then(() => {})
      .catch(() => {});
    this.getStats();
  }
};
</script>

<style scoped>
header {
  position: relative;
  padding-top: 7rem;
  padding-bottom: 7rem;
  background: linear-gradient(150deg, #0599a9 40%, #f26526 94%);
  background-size: cover;
  overflow: hidden;
}

.stats {
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: contain !important;
}
.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.2) !important;
}
.photo {
  height: 250px !important;
  border-radius: 10px;
}

.explore-card {
  border-radius: 10px;
  height: 246px;
}

@media screen and (max-width: 600px) {
  .border-right {
    border-right: 0 !important;
  }
  .explore-heading {
    font-size: 23px;
  }
}
</style>
